import type { PublicDisplaySnapshot } from "./types";

export const SNAPSHOT_CACHE_KEY = "food-safety-display:snapshot";

export interface SnapshotStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export function saveCachedSnapshot(storage: SnapshotStorage, snapshot: PublicDisplaySnapshot): void {
  storage.setItem(SNAPSHOT_CACHE_KEY, JSON.stringify(snapshot));
}

export function loadCachedSnapshot(storage: SnapshotStorage): PublicDisplaySnapshot | null {
  const rawValue = storage.getItem(SNAPSHOT_CACHE_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue) as PublicDisplaySnapshot;
  } catch {
    storage.removeItem(SNAPSHOT_CACHE_KEY);
    return null;
  }
}
